import { useCallback, useContext, useEffect, useState } from "react";
import { SlotMachineContext, SocketContext } from "../context";
import { ICard } from "../interfaces";

const useStrengthCards = () : [ICard[]] => {
    const { socket, randomOneStrengthCardSocketOn, newRandomStrengthCard } = useContext(SocketContext);
    const { lastDroppedCard, allStrengthCardsIdsState } = useContext(SlotMachineContext);
    const [recievedStrengthCards, setRecievedStrengthCards] = useState<ICard[]>([]);

    useEffect( () => {
        socket?.emit("generateRandomStrengthCards");
    }, [socket]); 

    useEffect(() => {
        randomOneStrengthCardSocketOn();
    }, [randomOneStrengthCardSocketOn]);

    const pushTheNewStrengthCard = useCallback((data: any) => {
        let allStrengthCardsIds : any[] = [];
        const recievedCard: any[] = data.map((item: any) => {

            allStrengthCardsIds.push(item._id || 0);

            return {
                backImagePath: "",
                description: item?.description || "x",
                info: item?.information || "x",
                id: item._id,
                type: "StrengthCard"
            }
        });

        allStrengthCardsIdsState.current = allStrengthCardsIds;
        setRecievedStrengthCards(recievedCard);
    }, [allStrengthCardsIdsState])

    useEffect(() => {
        socket?.on("randomStrengthCards", (data) => {
            pushTheNewStrengthCard(data);
        });

        return () => {
            socket?.off("randomStrengthCards");
        };
    }, [pushTheNewStrengthCard, socket]);

    useEffect( () => {
        let allStrengthCardsIds : any[] = [];
        
        const newArray = recievedStrengthCards.map( (card: any ) => {          

            if(card.id === lastDroppedCard?.id){
                allStrengthCardsIds.push(lastDroppedCard?.id || 0);
                return {
                    backImagePath: "",
                    description: newRandomStrengthCard?.description,
                    id: newRandomStrengthCard?._id,
                    info: newRandomStrengthCard?.information,
                    type: "StrengthCard"
                }
            }

            allStrengthCardsIds.push(card.id);
            return card;
        });

        allStrengthCardsIdsState.current = allStrengthCardsIds;
        setRecievedStrengthCards(newArray);
    // No cards will be shown in slot machine   
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newRandomStrengthCard]);

    return [recievedStrengthCards];
}

export default useStrengthCards;